import * as _ from "lodash";
import * as Constants from "../common/constants";
import { createWebServiceDataSource } from "../common/data";
import * as Global from "../common/global";
import * as GridUtil from "../common/gridFilter";
import * as UI from "../common/ui";
import { IApplication } from "../interfaces/application";
import { IController } from "../interfaces/controller";

// classes used to display a list of users

// parameters for filtering the list
export interface IUsersListFilter {
    SearchText?: string;
}

export class UsersController implements IController {
    // private properties

    // controls
    private grid: kendo.ui.Grid;
    private dataSource: kendo.data.DataSource;
    private gridFilterControl: GridUtil.GridFilterControl;
    private dateFormat: string;

    // references to DOM elements
    private gridContainer: JQuery;

    constructor() {
        const app: IApplication = Global.app();
        const customerSettings = app.userSession ? app.userSession.CustomerSettings : [];
        this.dateFormat = UI.GetCustomerSetting(customerSettings, Constants.SETTING_KEY_DATEFORMAT, Constants.DEFAULT_DATE_FORMAT);
    }

    // public methods

    // outputs the control to the HTML
    // returns a jQuery promise.
    public render(container: JQuery): JQueryPromise<any> {
        const me: UsersController = this;
        const app: IApplication = Global.app();
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();

        me.gridContainer = container.find("div[data-id='grid']");

        // create the grid
        me.dataSource = new kendo.data.DataSource({
            pageSize: 100,
        });

        me.grid = me.gridContainer.kendoGrid({
            dataSource: me.dataSource,
            selectable: false,
            sortable: true,
            filterable: true,
            pageable: true,
            columns: [
                { title: "Login Name", field: "UserName", template: kendo.template($("#template_users_username").html()) },
                { title: "User Name", field: "FullName" },
                { title: "Email", field: "Email" },
                {
                    title: "Created Date",
                    field: "DateTimeCreated",
                    template: `#= DateTimeCreated === null ? " " : kendo.toString(DateTimeCreated, "${UI.getKendoDateFormat(me.dateFormat)}")#`,
                    width: "220px",
                    filterable: {
                        ui: (element: any): any => {
                            element.kendoDatePicker({
                                format: UI.getKendoDateFormat(me.dateFormat),
                            });
                        },
                    },
                },
            ],
            excel: {
                fileName: "Users.xlsx",
                filterable: true,
                allPages: true,
            },
        }).data("kendoGrid");

        me.gridFilterControl = new GridUtil.GridFilterControl(container.find("div[data-id='filter']"), {
            showTextSearch: true,
            showExportToExcel: true,
            showFilters: true,
            showRefresh: true,
            filters: [
                { name: Constants.PHRASE_FILTER_SHOWACTIVE, checked: true },
                { name: Constants.PHRASE_FILTER_SHOWINACTIVE, checked: false },
            ],
            grid: me.grid,
        });

        // bind to all link tags in the grid
        me.gridContainer.on("click", "a[data-id='link']", function(e: any): boolean {
            const path: string | undefined = $(this).attr("href");
            e.preventDefault();
            // open the page
            app.router().navigate(_.defaultTo<string>(path, ""), true);
            return false;
        });

        deferred.resolve();

        return deferred.promise();
    }

    // put data into this control.
    // call after rendering the control
    public load(params: any[]): JQueryPromise<any> {
        const app: IApplication = Global.app();
        const me: UsersController = this;
        let dataSource: kendo.data.DataSource;
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();

        dataSource = createWebServiceDataSource(
            "/api/Users",
            {
                id: "ID",
                fields: {
                    ID: { type: "long" },
                    UserName: { type: "string" },
                    FullName: { type: "string" },
                    Email: { type: "string" },
                    DateTimeCreated: { type: "date" },
                    IsActive: { type: "boolean" },
                },
            },
            (data: any) => {
                me.setDataFilter(data);
            },
            (status: number) => {
                if (status === Constants.HTTP_STATUS_UNAUTHORIZED) {
                    // user is not allowed to view this data, so close the page
                    app.pageManager().closeCurrentPage();
                }
                // for other errors, keep page open, allow user to retry.
            });

        // load data into the grid by calling a web service
        me.grid.setDataSource(dataSource);

        deferred.resolve();
        return deferred.promise();
    }

    public add(): void {
        Global.app().router().navigate("/User", true);
    }

    public haveFieldsChanged(): boolean {
        // no editable fields
        return false;
    }

    public height(height: number): void {
        if (height > GridUtil.GRIDFILTERCONTROL_HEIGHT) {
            UI.resizeGrid(this.gridContainer, height - GridUtil.GRIDFILTERCONTROL_HEIGHT);
        }
    }

    // called when loaded page is redisplayed
    public refresh(): void {
        this.grid.dataSource.read();
    }

    // returns a unique ID for the control, so it can be redisplayed if
    // already open.  Used by the AppRouter class.
    public appRouterID(params: string[]): string {
        return "Users";
    }

    // returns a title for the page
    public title(): string {
        return "Users";
    }

    public subTitle(): string {
        return "";
    }

    private setDataFilter(data: any): void {
        data.IncludeActive = true;
        data.IncludeInactive = false;

        if (this.gridFilterControl != null) {
            this.gridFilterControl.setDataFilter(data);
        }
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/controllers/users.ts